// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1WHm8","validationTips":"StatementDescriptor_validationTips__4TjX9"};